module.exports = __webpack_public_path__ + "static/img/3.9aed68f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menthu/2/3.png
// module id = OqVR
// module chunks = 0